import { action, orchestrator, mutatorAction } from "satcheljs";
import { getStore } from "../store/tabStore";
import activateTab from "../actions/activateTab";
import type TabViewState from "../store/schema/TabViewState";

export interface ADD_TAB_VIEW_STATEActionMessage {
    viewState: TabViewState;
    makeActive: boolean;
}
export const addTabViewState: (viewState: TabViewState, makeActive: boolean) => ADD_TAB_VIEW_STATEActionMessage = action("ADD_TAB_VIEW_STATE", (viewState: TabViewState, makeActive: boolean): ADD_TAB_VIEW_STATEActionMessage => ({
    viewState,
    makeActive,
}));

export default addTabViewState;

// Put the orchestrator here because we need it to be sync so that popout can work correctly
orchestrator(addTabViewState, actionMessage => {
    const { viewState, makeActive } = actionMessage;
    const store = getStore();
    addTabToStore(viewState);
    
    if (makeActive) {
        // Use the reference from the store (http://aka.ms/mobx4)
        activateTab(store.tabs[store.tabs.length - 1]);
    }
});

/* eslint-disable-next-line owa-custom-rules/require-add-identifier-to-mutator-action-variables -- (https://aka.ms/OWALintWiki)
 * Mutator action variables should end with 'Mutator' so that we can more easily identify potential misuses of it.
 *	> Please add 'Mutator' substring add the end of the mutator action variable name. */
const addTabToStore = mutatorAction("addTabToStore", (viewState: TabViewState) => {
    const store = getStore();
    store.tabs.push(viewState);
});
